<template>
  <b-modal
    id="advance-close-advisor-comment-confirm"
    size="lg"
    title="ความคิดเห็นจากที่ปรึกษา"
    ok-title="ยืนยัน"
    ok-variant="primary"
    cancel-title="ยกเลิก"
    @ok="submit"
    @hidden="close"
  >
    <p class="text-center">กรุณากรอกความคิดเห็นที่มีต่อโครงการนี้</p>
    <b-form-textarea
      v-model="comment"
      rows="6"
      max-rows="15"
      wrap="hard"
    />
  </b-modal>
</template>

<script>
export default {
  data: () => ({
    comment: ''
  }),
  methods: {
    async submit () {
      await this.$store.dispatch('project/advanceWithAdvisorComment', {
        id: this.$route.params.id,
        comment: this.comment
      })

      this.$bvToast.toast('อนุมัติการปิดโครงการสำเร็จ', {
        title: 'แจ้งเตือน',
        variant: 'success',
        solid: true,
        noCloseButton: true
      })
    },
    close () {
      this.$emit('closed')
    }
  }
}
</script>
